import styled from "styled-components";

export default function VideoModal({ isOpen, onClose, url }: { isOpen: boolean; onClose: () => void; url: string }) {
  return (
    <VideoModalWrap $isOpen={isOpen} onClick={onClose}>
      <ModalContent>
        <VideoFrame id="video-iframe" src={url} allowFullScreen />
      </ModalContent>
    </VideoModalWrap>
  );
}

const VideoModalWrap = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  justify-content: center;
  z-index: 10000;
`;

const ModalContent = styled.div`
  position: relative;
  width: 60%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const VideoFrame = styled.iframe`
  width: 100%;
  min-height: 600px;
  border: none;
  margin: auto;
`;
